import { Deserializable } from '../deserializable.model';
import { Injectable } from "@angular/core";

@Injectable()
export class MyPropertyModel implements Deserializable {
  ID: number;
  Property_Name: string;
  Property_Address: string;
  Expiry_Date: Date;
  Price: Number;
  Image: string;

  deserialize(input: any): this {
    return Object.assign(this, input);
  }
}
